import React from 'react'
import './Navbar.css';

function Navbar() {
  return (
    <div className='navbar'>
        <div className='logo'>
           Fatima Hospital & Diagnostic Centre
        </div>

        <div className='nav-cta'>
          <button>Call Us</button>
        </div>
    </div>
  )
}

export default Navbar